import axios from 'axios';
import showMessage from "../utils/alert"
import router from "../router/index"
import store from '../store';
import { clearSessionData } from '@/utils/local_storage';
// import store from '../store';
// import { LOGOUT } from '../actions/types';

// Create an instance of axios
const api = axios.create({
    baseURL: process.env.VUE_APP_ADMIN_END_POINT,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `${localStorage.getItem("IdToken")}`
    }
  });

  // Function to update the Authorization header with the latest token
function updateAuthorizationHeader() {
    const token = localStorage.getItem("IdToken");
    api.defaults.headers['Authorization'] = token ? token : '';
  }
  
  // Add a request interceptor
api.interceptors.request.use(
    (config) => {
      // Update the Authorization header before each request is sent
      updateAuthorizationHeader();
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

/*
  NOTE: intercept any error responses from the api
 and check if the token is no longer valid.
 ie. Token has expired or user is no longer
 authenticated.
 logout the user if the token has expired
*/
api.interceptors.response.use(
  (res) => {
    const body = res.data.body ? res.data.body : {}
    
    const statusCode = res.data.statusCode;

    if(statusCode === 403) {
      localStorage.removeItem("IdToken");
      showMessage(res.data.message, "error")
      setTimeout(()=>{
        location.replace('/'); 
      },1000)

    } else if(statusCode === 401) {
        showMessage("Unauthorized request", "error")
        router.push({ name: 'login' });
        
    } else if("FORCE_CHANGE_PASSWORD" in body) {
        showMessage("Please, change your temporary password!", "info")
        router.push({ name: 'change-temp-password' });

    } else if(body.message){

        if(body.message === "Password is already reset."){
            showMessage(body.message,  "info")
            router.push({ name: 'login' });
        }
             
        if(statusCode  >  300){
            showMessage(body.message,  "error")

        }else if(statusCode === 200){
            showMessage(body.message,  "success")
        }
    }
    return res
  },
  (err) => {
      console.log(JSON.stringify(err));
      console.log(err);
      // store.commit('setLayout', 'auth');
    // window.location.replace('/'); // Redirect to the login page
    return Promise.reject(err);
  }
);

export default api;
